import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Fleet from './pages/Fleet';
import Tracking from './pages/Tracking';
import Blog from './pages/Blog';
import About from './pages/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { SaasAuthProvider } from './context/SaasAuthContext';
import SaasLogin from './components/SaaS/Login';
import SaasRegister from './components/SaaS/Register';
import SaasLayout from './components/SaaS/SaasLayout';
import SaasDashboard from './components/SaaS/Dashboard';
import SaasProtectedRoute from './components/SaaS/ProtectedRoute';
import VehicleManager from './components/SaaS/Vehicles/VehicleManager';
import DriverManager from './components/SaaS/Drivers/DriverManager';
import ClientManager from './components/SaaS/Clients/ClientManager';
import FinanceManager from './components/SaaS/Finance/FinanceManager';
import RouteManager from './components/SaaS/Routes/RouteManager';
import ReportManager from './components/SaaS/Reports/ReportManager';
import SettingsManager from './components/SaaS/Settings/SettingsManager';
import QuotationPage from './pages/Quotation/QuotationPage';

function App() {
  return (
    <SaasAuthProvider>
      <Router>
        <Routes>
          {/* Rutas públicas del sitio web principal */}
          <Route path="/" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Home />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/cotizacion" element={
            <>
              <QuotationPage />
            </>
          } />
          <Route path="/servicios" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Services />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/flota" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Fleet />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/seguimiento" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Tracking />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/contacto" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Contact />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/blog" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <Blog />
                </main>
                <Footer />
              </div>
            </>
          } />
          <Route path="/about" element={
            <>
              <Navbar />
              <div className="min-h-screen flex flex-col justify-between">
                <main className="flex-1">
                  <About />
                </main>
                <Footer />
              </div>
            </>
          } />
          
          {/* Rutas de autenticación del SaaS */}
          <Route path="/login" element={<SaasLogin />} />
          <Route path="/register" element={<SaasRegister />} />
          
          {/* Rutas protegidas del SaaS */}
          <Route path="/dashboard" element={
            <SaasProtectedRoute>
              <SaasLayout />
            </SaasProtectedRoute>
          }>
            <Route index element={<SaasDashboard />} />
            <Route path="vehicles" element={<VehicleManager />} />
            <Route path="drivers" element={<DriverManager />} />
            <Route path="clients" element={<ClientManager />} />
            <Route path="routes" element={<RouteManager />} />
            <Route path="finance" element={<FinanceManager />} />
            <Route path="reports" element={<ReportManager />} />
            <Route path="settings" element={<SettingsManager />} />
          </Route>
          
        </Routes>
      </Router>
    </SaasAuthProvider>
  );
}

export default App;
